import { render } from "./login.vue?vue&type=template&id=b3468dd0&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=b3468dd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b3468dd0"

export default script